import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import axios from 'axios';
import { ShowLoader } from '../../redux/actions/loader';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../components/input/input';

const TeacherSuggestion = (props) => {
    const dispatch = useDispatch();
    const [focusData, setFocusData] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const boxRef = useRef(null);
    const inputRef = useRef(null); // Add ref for the input
    const [FilterData, setFilterData] = useState([]);
    const [updatedValue, setUpdatedValue] = useState('');
    const url = useSelector((state) => state.Api);
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;

    function isInteger(value) {
        const intValue = parseInt(value);
        return !isNaN(intValue) && intValue.toString() === value.toString();
    }

    function filterSuggestions(inputValue = '') {
        return props.Suggestions?.filter(item => 
            item.roll ?
                isInteger(inputValue) ? 
                    item.roll.toString().includes(inputValue) 
                    : 
                    item.name.toString().toLowerCase().includes(inputValue.toLowerCase())
                :
                item.name.toString().toLowerCase().includes(inputValue.toLowerCase())
        ) || [];
    }

    function handleInputChange(e) {
        const inputValue = e.target.value;
        const filtered = filterSuggestions(inputValue);
        setFilterData(filtered);
        setUpdatedValue(inputValue);
        if (props.simple !== 'true') {
            // props.handleInputChange(e);
        }
    }

    function toggleShowAll() {
        setShowAll(!showAll);
        if (!showAll) {
            setFilterData(props.Suggestions || []);
            setFocusData(true);
        }
    }

    function getValue(selectedItem) {
        let value;
        if (selectedItem.roll !== undefined) {
            const e = {
                target: {
                    value: selectedItem.roll,
                    name: props.name
                }
            };
            
            props.handleInputChange(e);
            
            if (props.simple === 'true') {
                props.handleInputChange([props.name, selectedItem.roll]);
            }
            
            value = selectedItem.name ? 
                `${selectedItem.roll} , ${selectedItem.name} , ${selectedItem.Name_P || ''}` 
                : selectedItem.roll;
        } else {
            value = selectedItem.name;
        }
        
        setUpdatedValue(value);
        setFocusData(false);
        setShowAll(false);
        
        // Maintain focus after selection
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }

    useEffect(() => {
        const handleMouseDown = (event) => {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                setFocusData(false);
                setShowAll(false);
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(ShowLoader('1'));
                if (!url.teachersuggestion) {
                    console.error("url.teachersuggestion is undefined");
                    return;
                }
        
                const res = await axios.get(url.teachersuggestion, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userToken}`
                    }
                });
        
                if (res.status === 200) {
                    dispatch(ShowLoader('0'));
                    setFilterData(res.data.message);
                }
            } catch (error) {
                console.error("Error fetching teacher suggestions:", error);
                dispatch(ShowLoader('0'));
            }
        };
    
        // fetchData();
    }, [url.teachersuggestion, userToken]);

    return (
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', maxWidth: '800px' }}>
            <Input
                ref={inputRef} // Attach the ref
                onChange={handleInputChange}
                onFocus={() => setFocusData(true)}
                sx={{ width: '100%' }}
                required
                name={props.name}
                placeholder={props.placeholder}
                value={updatedValue}
                autoComplete="off"
            />
            <IconButton 
                onClick={toggleShowAll}
                sx={{ 
                    position: 'absolute', 
                    right: '8px',
                    color: 'action.active',
                }}
            >
                <ArrowDropDownIcon />
            </IconButton>
            
            {(FilterData?.length > 0 && (focusData || showAll)) && (
                <Box
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        top: '100%',
                        maxWidth: '800px',
                        boxShadow: '0px 5px 11px 0px #d7d7d7',
                        zIndex: 6,
                        background: 'white',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        mt: 1
                    }}
                    ref={boxRef}
                >
                    {FilterData.map((item, ind) => (
                        <Box
                            key={ind}
                            onClick={() => getValue(item)}
                            sx={{
                                padding: '10px',
                                cursor: 'pointer',
                                zIndex: 6,
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            {item.roll ? 
                                `${item.roll} , ${item.name} , ${item.Name_P || ''}`
                                : 
                                item.name
                            }
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

TeacherSuggestion.propTypes = {
    Suggestions: PropTypes.array,
    handleInputChange: PropTypes.func,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    simple: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default TeacherSuggestion;